import { ActionTree } from "vuex";

import { calculos } from "@/components/parent/manipulacaoNew/manipulacaoUtils";
import TiposCalculoManipulacao from "@/models/enum/tiposCalculoManipulacao";
import TiposItemManipulacao from "@/models/enum/tiposItemManipulacao";
import ManipulacaoOrdemItemModel from "@/models/manipulacaoOrdemItemModel";
import ManipulacaoOrdemModel from "@/models/manipulacaoOrdemModel";
import ManipulacaoOrdemService from "@/services/manipulacaoOrdemService";

import { AppState } from "../store";

import {
    ActionItemType,
    ItemTableType,
    ManipulacaoContextNewMutations,
    ManipulacaoContextNewState,
    ManipulacaoContextUUIDNew,
    ResetManipulacaoType,
    UpdateItemType,
} from "./types";

const manipulacaoOrdemService = new ManipulacaoOrdemService();

let qspTimer: any;
let doseTimer: any;

const actions: ActionTree<Map<string, ManipulacaoContextNewState>, AppState> = {
    ADD_NEW_CONTEXT_NEW(context, id: string) {
        context.commit(ManipulacaoContextNewMutations.ADD_NEW_CONTEXT_NEW, id);
    },
    RESET_MANIPULACAO_NEW(context, data: ManipulacaoContextUUIDNew<ResetManipulacaoType>) {
        context.commit(ManipulacaoContextNewMutations.RESET_MANIPULACAO_NEW, data);
    },
    UPDATE_MANIPULACAO_NEW(context, data: ManipulacaoContextUUIDNew<ManipulacaoOrdemModel>) {
        context.commit(ManipulacaoContextNewMutations.UPDATE_MANIPULACAO_NEW, data);
    },
    CONSOLIDAR_NEW(context, data: ManipulacaoContextUUIDNew<ManipulacaoOrdemModel>) {
        context.commit(ManipulacaoContextNewMutations.CONSOLIDAR_NEW, data);
    },
    UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW(context, data: ManipulacaoContextUUIDNew<ManipulacaoOrdemModel>) {
        context.commit(ManipulacaoContextNewMutations.UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW, data);
    },
    async ADD_ITEM_MANIPULACAO_NEW(context, { uuid, data }: ManipulacaoContextUUIDNew<ActionItemType>) {
        const state = context.state.get(uuid);

        if (!state || state.uploadingEditingModel || state.isDesabilitado) {
            return;
        }

        if (data.item && !state.ativos.some(p => p.ativoPrincipal) && data.type === ItemTableType.ATIVO) {
            data.item.ativoPrincipal = true;
        }

        // Remove a refencia caso tenha
        let itemAdd = { ...data.item } as ManipulacaoOrdemItemModel;

        if (itemAdd) {
            itemAdd = await calculos.valorTotal(itemAdd, data.type, state);

            data.item = { ...itemAdd } as ManipulacaoOrdemItemModel;
        }

        context.commit(ManipulacaoContextNewMutations.ADD_ITEM_MANIPULACAO_NEW, { uuid, data });
    },
    REMOVE_ITEM_MANIPULACAO_NEW(context, data: ManipulacaoContextUUIDNew<ActionItemType>) {
        context.commit(ManipulacaoContextNewMutations.REMOVE_ITEM_MANIPULACAO_NEW, data);
    },
    REMOVE_ALL_ITENS_BY_TYPE_NEW(context, data: ManipulacaoContextUUIDNew<ItemTableType>) {
        context.commit(ManipulacaoContextNewMutations.REMOVE_ALL_ITENS_BY_TYPE_NEW, data);
    },
    UPDATE_ITENS_KIT_EMBALAGEM_NEW(context, data: ManipulacaoContextUUIDNew<ManipulacaoOrdemItemModel[]>) {
        context.commit(ManipulacaoContextNewMutations.UPDATE_ITENS_KIT_EMBALAGEM_NEW, data);
    },
    UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW(context, data: ManipulacaoContextUUIDNew<number>) {
        context.commit(ManipulacaoContextNewMutations.UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW, data);
    },
    async UPDATE_KIT_EMBALAGEM_ID_NEW(context, { uuid, data }: ManipulacaoContextUUIDNew<number>) {
        const state = context.state.get(uuid);

        if (
            !state ||
            state.manipulacao.destino == null ||
            data == state.manipulacao.kitEmbalagemId ||
            state.uploadingEditingModel ||
            state.isDesabilitado
        ) {
            return null;
        }

        try {
            const embalagem = await state.manipulacaoOrdemService
                .definirEmbalagem(state.manipulacao, data, state.manipulacao.usaMarkupEquinos, state.isTransferencia)
                .resolveWithJSON<ManipulacaoOrdemModel>();

            context.commit(ManipulacaoContextNewMutations.REMOVE_EMBALAGENS_BY_KIT_ID_NEW, {
                uuid,
                data: state.manipulacao.kitEmbalagemId,
            });

            for (let index = 0; index < embalagem.itens.length; index++) {
                const item = embalagem.itens[index];
                item.tipoItem = TiposItemManipulacao.Embalagem;
                item.kitEmbalagemId = embalagem.kitEmbalagemId;

                await context.dispatch(ManipulacaoContextNewMutations.ADD_ITEM_MANIPULACAO_NEW, {
                    uuid,
                    data: { item, type: ItemTableType.EMBALAGEM, noAddIfExists: true },
                });
            }
            context.commit(ManipulacaoContextNewMutations.UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW, {
                uuid,
                data: embalagem.kitEmbalagemId,
            });
        } catch {}
    },
    async CALCULAR_QSP_NEW(
        context,
        {
            uuid,
            data: { loadDadosLote = true, ignoreDebounce = false },
        }: ManipulacaoContextUUIDNew<{ loadDadosLote: boolean; ignoreDebounce: boolean }>,
    ) {
        clearTimeout(qspTimer);

        if (ignoreDebounce) {
            await calculaQSP();
        } else {
            qspTimer = setTimeout(calculaQSP, 500);
        }

        async function calculaQSP() {
            const state = context.state.get(uuid);
            if (!state) {
                return;
            }

            if (state.uploadingEditingModel || state.isDesabilitado) {
                return;
            }

            const data = await manipulacaoOrdemService
                .calcularQSP(state.manipulacao, state.manipulacao.usaMarkupEquinos, state.isTransferencia)
                .resolveWithJSON<ManipulacaoOrdemModel>();

            context.commit(ManipulacaoContextNewMutations.CALCULAR_QSP_NEW, {
                uuid,
                data: data.itens.filter(
                    p =>
                        (p.tipoItem == TiposItemManipulacao.MateriaPrima ||
                            p.tipoItem == TiposItemManipulacao.FormulaPadrao) &&
                        p.produtoPai == null,
                ),
            });
        }
    },
    async CALCULA_DOSE_NEW(context, data: ManipulacaoContextUUIDNew<null>) {
        const state = context.state.get(data.uuid);
        if (!state) {
            return;
        }

        clearTimeout(doseTimer);
        doseTimer = setTimeout(async () => {
            if (
                !state.manipulacao.formaFarmaceutica.concentracaoMaxima ||
                state.uploadingEditingModel ||
                state.manipulacao.trocouDoseManualmente
            ) {
                return;
            }

            const volumeDose = await manipulacaoOrdemService.calcularDose(state.manipulacao).resolveWithJSON<number>();

            if (volumeDose > 0) {
                context.commit(ManipulacaoContextNewMutations.REPLICA_DOSE_ATIVOS_NEW, {
                    uuid: data.uuid,
                    data: { dose: volumeDose, isTrocaManual: state.manipulacao.trocouDoseManualmente },
                });
            }
        }, 200);
    },
    REPLICA_DOSE_ATIVOS_NEW(context, data: ManipulacaoContextUUIDNew<{ dose: number; isTrocaManual?: boolean }>) {
        context.commit(ManipulacaoContextNewMutations.REPLICA_DOSE_ATIVOS_NEW, data);
    },
    SET_UPLOADING_EDITING_MODEL_NEW(context, data: ManipulacaoContextUUIDNew<boolean>) {
        context.commit(ManipulacaoContextNewMutations.SET_UPLOADING_EDITING_MODEL_NEW, data);
    },
    SET_UPLOADING_PREVENDA_NEW(context, data: ManipulacaoContextUUIDNew<boolean>) {
        context.commit(ManipulacaoContextNewMutations.SET_UPLOADING_PREVENDA_NEW, data);
    },
    SET_IS_CAPSULA_NEW(context, data: ManipulacaoContextUUIDNew<boolean>) {
        context.commit(ManipulacaoContextNewMutations.SET_IS_CAPSULA_NEW, data);
    },
    SET_IS_CONSOLIDANDO_NEW(context, data: ManipulacaoContextUUIDNew<boolean>) {
        context.commit(ManipulacaoContextNewMutations.SET_IS_CONSOLIDANDO_NEW, data);
    },
    SET_IS_DESABILITADO_NEW(context, data: ManipulacaoContextUUIDNew<boolean>) {
        context.commit(ManipulacaoContextNewMutations.SET_IS_DESABILITADO_NEW, data);
    },
    REMOVE_ATIVOS_ASSOCIADOS_NEW(context, data: ManipulacaoContextUUIDNew<null>) {
        context.commit(ManipulacaoContextNewMutations.REMOVE_ATIVOS_ASSOCIADOS_NEW, data);
    },
    REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW(context, data: ManipulacaoContextUUIDNew<null>) {
        context.commit(ManipulacaoContextNewMutations.REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW, data);
    },
    REMOVE_DESMEMBRADOS_NEW(context, data: ManipulacaoContextUUIDNew<null>) {
        context.commit(ManipulacaoContextNewMutations.REMOVE_DESMEMBRADOS_NEW, data);
    },
    async CALCULAR_QUANTIDADES_ITEM_NEW(context, { uuid, data }: ManipulacaoContextUUIDNew<UpdateItemType>) {
        const state = context.state.get(uuid);
        if (!state) {
            return;
        }

        let item: ManipulacaoOrdemItemModel | null = null;

        switch (data.type) {
            case ItemTableType.ATIVO:
                item = state.ativos[data.index];
                break;
            case ItemTableType.EMBALAGEM:
                item = state.embalagens[data.index];
                break;
            case ItemTableType.CAPSULA:
                item = state.capsulas[data.index];
                break;
        }

        // Se for produto associado não deve recalcular os valores pois irá calcular ao inserir novamente os ativos na consolidação
        if (
            !data.force &&
            (state.uploadingEditingModel ||
                state.isDesabilitado ||
                !item ||
                item.produtoAssociadoPaiId ||
                item.quantidadeAlteradaManualmente)
        ) {
            return;
        }

        let quantidade = 0;
        let indiceConversao = 1;
        const converter =
            item.tipoCalculo != TiposCalculoManipulacao.UTRPercentual &&
            item.tipoCalculo != TiposCalculoManipulacao.UIPercentual;

        if (converter) {
            indiceConversao = await state.indicesConversoesUnidadeMedidasService.getIndiceConversao(
                item.unidadeMedidaManipulacaoId,
                item.unidadeMedidaId,
                item.densidade,
                item.produtoId,
                item.produtoLoteId,
            );
        }

        switch (item.tipoCalculo) {
            case TiposCalculoManipulacao.Unitario:
                quantidade = calculos.tipoCalculo.unitario(item, state);
                break;
            case TiposCalculoManipulacao.Percentual:
                quantidade = calculos.tipoCalculo.percentual(item, state.manipulacao.volumeTotal, state);
                break;
            case TiposCalculoManipulacao.UTRPercentual:
                quantidade = calculos.tipoCalculo.percentualUTR(item, state.manipulacao.volumeTotal);
                break;
            case TiposCalculoManipulacao.UIPercentual:
                quantidade = calculos.tipoCalculo.percentualUI(item, state.manipulacao.volumeTotal);
                break;
            case TiposCalculoManipulacao.Qsp:
                quantidade = item.quantidade;
                break;
            case TiposCalculoManipulacao.Dose:
                quantidade = calculos.tipoCalculo.dose(item, state);
                break;
            default:
                quantidade = calculos.tipoCalculo.nenhum(item);
        }

        // Se é QSP o número de formulas será considera no calculo do volume
        if (item.tipoCalculo != TiposCalculoManipulacao.Qsp) {
            quantidade = quantidade * (Number(state.manipulacao.numeroFormulas) ?? 1);
        }
        item.quantidade = Math.round(quantidade * 10000) / 10000;

        const quantidadeUnidadeEstoque = quantidade * indiceConversao;
        item.quantidadePesagem = Math.round(quantidadeUnidadeEstoque * 10000) / 10000;

        // Cenário em que a quantidade ficou menor que 4 decimais
        if (item.quantidadePesagem == 0) {
            item.quantidadePesagem = Math.round(quantidadeUnidadeEstoque * 10000000) / 10000000;
        }

        item = await calculos.valorTotal(item, data.type, state);

        context.commit(ManipulacaoContextNewMutations.SET_ITEM_DATA_NEW, {
            uuid,
            data: { index: data.index, type: data.type, item },
        });
    },
    UPDATE_MANIPULACAO_ITENS_NEW(
        context,
        { uuid, data }: ManipulacaoContextUUIDNew<{ itens: ManipulacaoOrdemItemModel[]; atualizaDadosLote: boolean }>,
    ) {
        const state = context.state.get(uuid);
        if (!state) {
            return;
        }
        state.atualizaDadosLote = data.atualizaDadosLote;

        state.ativos.forEach((item, index) => {
            const dado = data.itens.find(p => p.produtoId == item.produtoId);
            if (dado) {
                context.commit(ManipulacaoContextNewMutations.SET_ITEM_DATA_NEW, {
                    uuid,
                    data: { index, type: ItemTableType.ATIVO, item: dado },
                });
            }
        });
        state.embalagens.forEach((item, index) => {
            const dado = data.itens.find(p => p.produtoId == item.produtoId);
            if (dado) {
                context.commit(ManipulacaoContextNewMutations.SET_ITEM_DATA_NEW, {
                    uuid,
                    data: { index, type: ItemTableType.EMBALAGEM, item: dado },
                });
            }
        });
        state.capsulas.forEach((item, index) => {
            const dado = data.itens.find(p => p.produtoId == item.produtoId);
            if (dado) {
                context.commit(ManipulacaoContextNewMutations.SET_ITEM_DATA_NEW, {
                    uuid,
                    data: { index, type: ItemTableType.CAPSULA, item: dado },
                });
            }
        });
    },
    SET_ATIVO_PRINCIPAL_NEW(context, data: ManipulacaoContextUUIDNew<number>) {
        context.commit(ManipulacaoContextNewMutations.SET_ATIVO_PRINCIPAL_NEW, data);
    },
    SET_FRANQUIA_FILIAL_NEW(
        context,
        { uuid, data }: ManipulacaoContextUUIDNew<{ isFranquiaFilial: boolean; estoqueFranquiaId: number }>,
    ) {
        context.commit(ManipulacaoContextNewMutations.SET_FRANQUIA_FILIAL_NEW, { uuid, data });
    },
    SET_KIT_EMBALAGEM_OPTIONS_NEW(context, { uuid, data }: ManipulacaoContextUUIDNew<Object[]>) {
        context.commit(ManipulacaoContextNewMutations.SET_KIT_EMBALAGEM_OPTIONS_NEW, { uuid, data });
    },
};

export default actions;
